import React from 'react';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';

interface Props {
  className?: any;
  bold?: any;
  underline?: any;
  disabledText?: any;
  crossedOut?: any;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      fontSize: 18,
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    underline: { textDecoration: 'underline' },
    crossedOut: { textDecoration: 'line-through' },
    disabledText: { color: '#cccccc' },
    bold: { fontWeight: 700 },
  }),
);

const RegularText: React.FC<Props> = ({ children, bold, underline, crossedOut, disabledText, className }) => {
  const classes = useStyles();
  return (
    <span
      className={clsx(classes.root, {
        [classes.bold]: bold,
        [classes.underline]: underline,
        [classes.crossedOut]: crossedOut,
        [classes.disabledText]: disabledText,
        [className]: className,
      })}
    >
      {children}
    </span>
  );
};

RegularText.defaultProps = {
  bold: false,
  underline: false,
  crossedOut: false,
  disabledText: false,
};

export default RegularText;
